export default "__VITE_ASSET__DRT7pJaP__"